var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"downloads-graph"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.values)?_c('BaseGraph',{attrs:{"values":_vm.values}}):_vm._e()],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ea24dd6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/DownloadsGraph.vue
// module id = 520
// module chunks = 0